import { ApiConfigBase } from "../api/ApiConfigBase";
import { ApiConfigCompany, BidNavVersion } from "../models/ApiConfigCompany";

class ApiConfig extends ApiConfigBase {
    getAvailableCompanies(): ApiConfigCompany[] {
        return  [            
            {
                "companyId": "UAL2",
                "displayName": "BidNav 2.0",
                "adminApiUrl": "https://admapitest.cclsoftware.com",
                "bidNavUrl": "https://faltest.bidnav.com",
                "bidNavApiUrl": "https://falapitest.bidnav.com",
                "bnKey": "B3D60D229E64438CA490E49D21762E9B",
                "currency": "$",
                "currencyCode": "USD",
                "defaultCountryCode": "us",
                "bases": [],
                "aircraft": [],
                "positions": [],
                "useStaticData": false,            
                "bidNavVersion": BidNavVersion.BidNav20
            },
            {
                "companyId": "UAL",
                "displayName": "UAL Legacy",
                "adminApiUrl": "https://admapi-leg-test.cclsoftware.com",
                "bidNavUrl": "https://bidnavtest.bidnav.com",
                "bidNavApiUrl": "https://bidnavtest.bidnav.com",
                "bnKey": "B3D60D229E64438CA490E49D21762E9B",
                "currency": "$",
                "currencyCode": "USD",
                "defaultCountryCode": "us",
                "bases": ["CLE", "DCA", "DEN", "EWR", "GUM", "IAH", "LAS", "LAX", "MCO", "ORD", "SEA", "SFO"],
                "aircraft": ["320", "737", "756", "777", "787"],
                "positions": ["FO", "CA"],
                "useStaticData": true,
                "bidNavVersion": BidNavVersion.Legacy
            }
        ];
    }
}

const Api_Config = new ApiConfig();
export default Api_Config;

